import { useEffect, useRef } from 'react';

export default function useAccessibleClick(onClick, inputRef = null) {
  const ref = inputRef || useRef(null);

  const handleKeyDown = (event) => {
    const isEnter = event.key === 'Enter';
    const isFocused = document.activeElement === ref.current;

    if (isEnter && isFocused) {
      onClick(event);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return ref;
}